import { safeParse } from '@/utils/json';
import { InitialRequest } from '@/types/requests';

export function parseGetParams (search: string) {
    let params = {};

    if (search && search.length > 0) {
        (search.slice(1) || '').split('&').forEach((pair) => {
            const [key, value] = pair.split('=');

            params[key] = safeParse(unescape(value));
        });
    }

    return params;
}

let cacheGetAddParams = {};
export function getAddParams (search: string) {
    if (cacheGetAddParams[search]) {
        return cacheGetAddParams[search];
    }

    const prefix = 'odr-';
    let addParams: Partial<InitialRequest> = {};
    let getParams = parseGetParams(search);
    Object.keys(getParams)
        .filter(key => key.indexOf(prefix) === 0)
        .forEach(key => {
            const initParamsPrefix = prefix + 'initParams-';

            if (key.indexOf(initParamsPrefix) === 0) {
                addParams.initParams = addParams.initParams || {};

                addParams.initParams[key.replace(initParamsPrefix, '')] = getParams[key];
            } else {
                addParams[key.replace(prefix, '')] = getParams[key];
            }
        });

    cacheGetAddParams[search] = addParams;
    return addParams;
}
